
import Vue from "vue";

import dialogCom from "@/components/ModelCom.vue";
import Utils from "@/assets/js/Utils";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import { CtrlType } from "@/assets/js/Model/InnerModel";
export default Vue.extend({
  components: { dialogCom },
  data() {
    return {
      dialog: null as any,
      logs: [] as any[],
      alarms: [] as any[],
      currentId: "log",
      count: 50,
      page: 0,
      page1: 0,
      sid: "" as string,
      currentPolicy: [] as any[],
      policyes: [] as any[],
      typesid: "",
      ctrlAddr: "",
    };
  },
  mounted() {
    this.dialog = this.$refs.dialog;
    this.page = 0;
    this.page1 = 0;
    this.handleClick();
  },
  methods: {
    opened() {
      this.$emit("opened");
    },
    show(sid: string, type: string, ctrlAddr: string) {
      this.sid = sid;
      this.typesid = type;
      this.ctrlAddr = ctrlAddr;
      this.page = 0;
      this.page1 = 0;
      this.logs = [];
      this.alarms = [];
      this.dialog.show();
      this.handleClick();
    },
    async freshPolicy() {
      var obj = {
        serials: [this.sid],
      };
      await HttpUtil.XCHttpPost(Urls.JGReadData, obj, true, false);

      window.setTimeout(async () => {
        await this.getPolicies();
      }, 2000);
    },

    async getPolicies() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceTimePolicy,
        { deviceSid: this.sid },
        true,
        false
      );
      this.policyes = ret;
      this.currentPolicy = [];
      this.policyes.forEach((x: any) => {
        this.currentPolicy.push(x.sid);
      });
    },
    hiden() {
      this.dialog.hiden();
    },
    more(type: number) {
      if (type == 0) {
        this.page += 1;
        this.selectLog();
      } else {
        this.page1 += 1;
        this.selectAlarm();
      }
    },
    async selectLog() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetJGRunSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.logs.push(x);
      });
    },
    async selectAlarm() {
      let obj = {
        count: this.count,
        skip: this.page * this.count,
        sid: this.sid,
      };
      if (!this.sid || this.sid.length == 0) {
        return;
      }
      obj.skip = this.page1 * this.count;
      const item: any[] = await HttpUtil.XCHttpPost(
        Urls.GetDeviceAlarmSingle,
        obj,
        true,
        false
      );
      item.forEach((x) => {
        this.alarms.push(x);
      });
    },
    async handleClick() {
      console.log(this.currentId);
      if (this.currentId == "log") {
        this.page = 0;
        this.logs = [];
        await this.selectLog();
      } else if (this.currentId == "policy") {
        // const dialog: any = this.$refs.policyDetail;
        // dialog.fresh();
        await this.getPolicies();
      } else {
        this.page1 = 0;
        this.alarms = [];
        await this.selectAlarm();
      }
    },
  },
});
